import React, { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import "./Navbar.css";
import UPPoliceLogo from "../assets/UP_Police.png";

function Navbar() {
  const { user, logout } = useContext(AuthContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo on the left */}
        <div className="navbar-brand">
          <div 
            className="brand-icon"
            style={{ backgroundImage: `url(${UPPoliceLogo})` }}
          ></div>
        </div>

        {/* Title in the center */}
        <div className="navbar-title">
          <span className="brand-title">Police Grievance  Management Portal- Kanpur Commissionerate</span>
          <span className="brand-subtitle">Feedback Management System</span>
        </div>

        {/* Navigation links on the right */}
        <div className={`navbar-links ${isMenuOpen ? "active" : ""}`}>
          {/* Show Dashboard link when not on dashboard */}
          {user && location.pathname !== "/" && (
            <Link to="/" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              <i className="fas fa-home"></i>Dashboard
            </Link>
          )}
          
          {/* Show Admin Panel link only for admin role and only when not on admin panel */}
          {user && user.role === "admin" && location.pathname !== "/admin" && (
            <Link to="/admin" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              <i className="fas fa-user-shield"></i>Admin Panel
            </Link>
          )}

          {/* Show Officer Dashboard link only for officer role and only when not on officer dashboard */}
          {user && user.role === "officer" && location.pathname !== "/officer" && (
            <Link to="/officer" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              <i className="fas fa-user-tie"></i>My Dashboard
            </Link>
          )}
          
          {user ? (
            <button onClick={logout} className="btn-logout">
              <i className="fas fa-sign-out-alt"></i>Logout
            </button>
          ) : (
            <Link to="/login" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              <i className="fas fa-sign-in-alt"></i>Login
            </Link>
          )}
        </div>

        <div className="hamburger-menu" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;